import 'css-chunksrc/client/pages/exportsPage/timesheetByTaskReport/filters/styles.scss';export default {
  "filters": "_filters_3c0o2_1",
  "resetButton": "_resetButton_3c0o2_17",
  "label": "_label_3c0o2_25",
  "section": "_section_3c0o2_32"
};